import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Typography } from '@material-ui/core';
// import DraftTable from '../../invoices/common/draftTable';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { CommonConfig } from '../../config/common-config';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import { userType } from '../../config/usertypeValue';
import InvoiceTable from './invoiceTable';
import SearchBox from '../../components/table/SearchBox';

const useStyles = makeStyles((theme) => ({
    btnbottom: {
        borderBottom: '#feef6',
    },

    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
            width: '100%',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileNameMargin: {
        marginTop: '6px',
        marginBottom: '0px'
    },
    flexRow: {
        flexDirection: 'row !important'
    },
    removeButton: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '15px !important'
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#747474',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
}));

export default function EMInvoice(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const history = useHistory();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;
    const stageID = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [proceedFlag, setProceedFlag] = useState(false);
    const [confirmView, setConfirmView] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    useEffect(() => {
        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
        } else {
            setSearchData([]);
            getInvoiceData();
        }
    }, [bearerToken, props, page])

    const getInvoiceData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/auth/list-generic-invoice/${tennantName}?page=${page}&size=10&sort=dateModified,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    // formatDate(response.data)
                    response.data.content.map((ele) => {
                        return ele.finalDocAndReports = JSON.parse(ele.finalDocAndReports)
                    })

                    setRows(response.data.content);
                    // handleRowChange(response.data);
                    setPageDetails(response.data);
                    // setLoading(false);
                    if (response.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (response.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult && errResult.data) {
                }
            });
    }

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    function formatDate(props) {
        return props.map((element) => {
            const tempStartDate = element.date;
            const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            const formatDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
            element.date = moment(formatDate).format('DD-MM-YYYY');
        });
    }

    const headcells = [
        // { id: 'slno', label: 'SL No' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Client name' },
        { id: 'dateofrequest', label: 'Date of Request' },
        { id: 'amount', label: 'Amount' },
    ];

    const navigateBack = () => {

        if (userType.detailAnalysisFlag) {
            const data = {
                serviceId: serviceIdValue,
            };

            axios
                .put(`${CommonConfig.dev.baseUrl}/api/itr/draft-statements/draft-crc/${tennantName}`, data, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    if (response.data === "SUCCESS") {
                        setTimeout(() => {
                            history.push({
                                pathname: '/menu/detailAnalysisCore',
                            });
                        }, 3000);
                    }
                })
                .catch(() => {
                });
        } else {
            history.push({
                pathname: '/menu/openservice',
            });
        }
    }

    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
        if (searchData && searchData.length > 2) {
            setPage(0);
            getSearchValue(searchData);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!searchData) {
            setSearchData([]);
            setPage(0);
            getInvoiceData();
        }
    };

    const getSearchValue = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/list-generic-invoice/${tennantName}?search=${data}&page=${page}&size=10&sort=dateModified,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((res) => {
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setRows([]);
                    }
                    res.data.content.map((ele) => {
                        return ele.finalDocAndReports = JSON.parse(ele.finalDocAndReports)
                    })
                    // console.log('res.data.content', res.data.content)
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getInvoiceData();
    }

    const addInvoice = () => {
        history.push({
            pathname: '/menu/add-invoices',
        });
    }

    // Search through nested objects
    // const filteredRow = searchQuery
    //     ? rows.filter((searchRow) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col)
    //             .some((key) => {
    //                 if (key.isConcat && searchRow[key.id]) {
    //                     const subdata = searchRow[key.id];
    //                     const mergedData = key.concatElem.map((concatdata) => {
    //                         return concatdata.split('.').reduce((acc, item) => {
    //                             if (Object.prototype.hasOwnProperty.call(acc, item)) {
    //                                 if (typeof acc[item] !== 'object') {
    //                                     return acc[item].toString().toLowerCase().includes(query);
    //                                 }
    //                                 return acc[item];
    //                             }
    //                             return false;
    //                         }, subdata);
    //                     });
    //                     return mergedData[0];
    //                 }
    //                 if (searchRow && searchRow[key.id]) {
    //                     return searchRow[key.id].toString().toLowerCase().includes(query);
    //                 } else {
    //                     return false;
    //                 }
    //             });
    //     })
    //     : rows;

    // const handleRowChange = (rowValue) => {
    //     setProceedFlag(false);
    //     rowValue.filter((ele) => {
    //         if (ele.finalVersionByIMC) {
    //             setProceedFlag(true);
    //         }
    //     })
    // }

    // const proceedToTax = () => {
    //     rows.filter((ele) => {
    //         ele.date = ele.date.split("-").reverse().join("-");
    //         const data = {
    //             serviceId: serviceIdValue,
    //             remarks: 'Remarks',
    //             draftDocuments: rows
    //         };

    //         axios
    //             .put(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/client-review/${tennantName}`, data, {
    //                 headers: {
    //                     Authorization: bearerToken,
    //                 },
    //             })
    //             .then((response) => {
    //                 if (response.data === 'SUCCESS') {
    //                     history.push({
    //                         pathname: '/menu/openservice',
    //                     });
    //                 }
    //             })
    //             .catch((error) => {
    //                 const errResult = error.response;
    //                 if (errResult.data) {
    //                 }
    //             });
    //     })
    // }

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <div>
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={4}>
                        <Typography className="card-title">Requested Invoices</Typography>
                    </Grid>
                    {stageID === 16 && rows && rows.length > 0 ? null :
                        <Grid item xs={12} sm={8} className="card-search">
                            <div className="search-field">
                                <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                            </div>
                            <div className="card-add-button">
                                <Button variant="outlined" color="primary" size="small" onClick={addInvoice} className={classes.button}>
                                    Request generic invoice
                                </Button>
                            </div>
                        </Grid>}
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length ? (
                        <>
                            <InvoiceTable
                                handleCount={handleCount}
                                stageID={stageID}
                                headcells={headcells}
                                rows={filteredRow}
                                action
                                pageDetails={pageDetails}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                loading={loading}
                            // handleRowChange={handleRowChange}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
            {stageID === 16 && rows && rows.length > 0 ?

                <Grid item xs={12} sm={12} style={{ display: 'flex', padding: '0px' }}>
                    <Grid item xs={12} sm={4} style={{ padding: '0px' }}>
                        <div className="footer-button">
                            <ul><li>
                                <Button color="primary" className="buttonnext txt-cap" onClick={navigateBack}>
                                    Back
                            </Button>
                            </li></ul>
                        </div>
                    </Grid>
                    {/* {stageID === 18 ?
                    <Grid item xs={12} sm={8} style={{ padding: '0px' }}>
                        <div className="footer-button">
                            <ul style={{ display: 'flex', float: 'right' }}><li style={{ margin: '0px' }}>
                                <Button color="primary" className="buttonnext txt-cap" disabled={!proceedFlag} onClick={() => setConfirmView(true)}>
                                    Proceed to attach final statements
                                </Button>
                            </li></ul>
                        </div>
                    </Grid> : null} */}
                </Grid>
                : ''}
        </div >
    );
}
